export default function buildSimpleColumns(records: Array<object>): Array<any> {
    if (records.length > 0) {
        const columns = Object.keys(records[0]).map(x => ({
            Header: x,
            accessor: d => d[x],
            id: x,
            style: { whiteSpace: "unset" },
            Cell: records => {
                if (records.value != null) return records.value.toLocaleString();
                else return records.value;
            },
        }));
        return columns;
    } else {
        return [];
    }
}
